import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const Physician: FC<ViewProps> = ({ report, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#physician`}>
        <Headding icon={<Edit icon={16} />}>産業医</Headding>
      </Link>
      <Item>
        <Grid>
          <Dl>
            <Dt>氏名</Dt>
            <Dd>{displayFormat(report.physicianName)}</Dd>
          </Dl>
        </Grid>
        <Dt>所属機関</Dt>
        <Grid>
          <Dl>
            <Dt>名称</Dt>
            <Dd>{displayFormat(report.physicianInstitutionName)}</Dd>
          </Dl>
          <Dl>
            <Dt>所在地</Dt>
            <Dd>{displayFormat(report.physicianInstitutionAddress)}</Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
